import React, { useCallback, useMemo, useState } from 'react'
import styles from './historySection.module.css'
import { DefaultTextItem } from './components/defaultTextItem/defaultTextItem.index';
import { HistoryHeaderItem } from './components/historyHeaderItem/historyHeaderItem.index';
import { CommentSection } from './components/commentSection/commentSection.index';
import { useInsights } from '../../../../Context/insightContext';
import { IEscalationComments } from '../../../../Models/applicationModels';
import { isTypeDraftComment } from './components/commentSection/components/commentItem/commentItem.utils';

interface HistorySectionProps {
    opportunityUid: string;
    applicationEscalationUid: string | null;
    commentItems: IEscalationComments[];
    setCommentItems: React.Dispatch<React.SetStateAction<IEscalationComments[]>>;
    initialStatus: string | null;
}

export const HistorySection = ({ opportunityUid, applicationEscalationUid, commentItems, setCommentItems, initialStatus }: HistorySectionProps) => {
    const isEscalationRaised = applicationEscalationUid !== null;
    const canAddComment = useMemo(() => (commentItems.filter((item) => isTypeDraftComment(item.commentType)).length) === 0 && initialStatus !== 'Closed' && isEscalationRaised, [commentItems, initialStatus, isEscalationRaised]);

    const handleCancelComment = useCallback((index: number) => {
        setCommentItems((prev: IEscalationComments[]) => prev.filter((_, i) => i !== index));
    }, [setCommentItems]);

    return (
        <div className={styles.historySection}>
            <HistoryHeaderItem canAddComment={canAddComment} setCommentItems={setCommentItems} applicationEscalationUid={applicationEscalationUid} opportunityUid={opportunityUid} /> 
            <div className={styles.historySectionContent}>
                { (isEscalationRaised && commentItems.length > 0)  ? (
                    <CommentSection commentItems={commentItems} handleCancelComment={handleCancelComment} opportunityUid={opportunityUid} setCommentItems={setCommentItems} initialStatus={initialStatus}/>
                ) : <DefaultTextItem isNoActivity={isEscalationRaised} /> }
            </div>
        </div>
    )
}
